"use strict";

/**
 * Bring a page banner into view and give it the focus.
 *
 * On a phone the page sits where the download dialog's link was, so a message
 * rendered on the dialog's close would land above the fold unseen. The focus
 * also makes assistive technology announce it; swiftref-dialog's focus return
 * (200ms after hide) yields once the focus has moved.
 *
 * Below 940px the header and the mobile tabs are sticky (client/style/header.css)
 * and would cover the banner: their height is MEASURED, not a CSS scroll-margin,
 * because the tabs wrap to two rows on narrow screens.
 */

const STICKY = "swiftref-header, swiftref-tabs#mobile-tabs";
const GAP = 16;

function _stickyBottom () {
    let bottom = 0;
    for (const el of document.querySelectorAll(STICKY)) {
        if (window.getComputedStyle(el).position === "sticky") {
            bottom = Math.max(bottom, el.getBoundingClientRect().bottom);
        }
    }
    return bottom;
}

function _scrollTo (container) {
    const covered = _stickyBottom();
    const box = container.getBoundingClientRect();
    if (box.top >= covered && box.bottom <= window.innerHeight) {
        return;   // already in view: leave the page where it is
    }
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({
        top: Math.max(0, window.scrollY + box.top - covered - GAP),
        behavior: reduced ? "auto" : "smooth"
    });
}

/**
 * The focus moves at once (so the dialog's focus return yields); the scroll waits
 * for the dialog's "hidden" event when one is still open: until then the phone
 * sheet holds the page scroll locked, and the sticky bars are not stuck, so
 * nothing could be measured or scrolled.
 *
 * @param {HTMLElement} container the banner's container (the scroll target)
 * @param {HTMLElement} banner the swiftref-banner just rendered into it
 */
function revealBanner (container, banner) {
    banner.setAttribute("tabindex", "-1");
    banner.focus({preventScroll: true});
    const dialog = document.querySelector("swiftref-dialog[open]");
    if (dialog) {
        dialog.addEventListener("hidden", function () {
            _scrollTo(container);
        }, {once: true});
    } else {
        _scrollTo(container);
    }
}

module.exports = revealBanner;
